import { PaymentStatus, PayMethod } from "../models/payment";
import { RecipeStatus } from "../models/recipe";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface PaymentListParams {
  state: PaymentStatus;
  current: number;
  size?: number;
  param?: string;
  registrationTimeHead?: string;
  registrationTimeTail?: string;
  treatmentDepartmentId?: string;
}

export function getPaymentList(params: PaymentListParams): Request {
  const action =
    params.state === RecipeStatus.ToSettle ? "noPaylist" : "paylist";
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/${action}`,
    method: "GET",
    params,
  };
}

export interface PayParams {
  payMethod: PayMethod;
  realPayAmount: string;
  receivePayAmount: string;
  recipeIdList: string[];
}

export function pay(params: PayParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/doPay`,
    method: "POST",
    body: params,
  };
}

export function getPaymentResult(paymentId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/detail`,
    method: "GET",
    params: {
      paymentId,
    },
  };
}

export function getPaymentDetail(paymentId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/detail`,
    method: "GET",
    params: {
      paymentId,
    },
  };
}

export function refund(paymentId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/refund`,
    method: "POST",
    params: {
      paymentId,
    },
  };
}

export interface GetPatientPaymentListParams {
  current?: number;
  size?: number;
  patientId?: string;
  departmentId?: number;
  timeHead?: string;
  timeTail?: string;
}

export function getPatientPaymentList(
  params: GetPatientPaymentListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/paymenthistory/list`,
    method: "GET",
    params,
  };
}
